import { forwardRef } from '@chakra-ui/react';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

import { COLOR_MAP_FULL, GOAL_PROGRESSES_PARTIAL_LABEL } from 'constants/ProjectConstants';

interface Props {
  data: Array<{
    name: string;
    value: number;
    color: string;
  }>;
  innerRadius?: number;
  outerRadius?: number;
}

export const COLOR_MAP_OKR_PIE_CHART = Object.keys(GOAL_PROGRESSES_PARTIAL_LABEL).map((statusKey) => ({
  key: statusKey,
  label: GOAL_PROGRESSES_PARTIAL_LABEL[statusKey],
  barColor: COLOR_MAP_FULL[statusKey]?.textColor,
}));

const StatusPieChart = forwardRef<Props, 'div'>(({ data, innerRadius = 22, outerRadius = 36 }, ref) => (
  <ResponsiveContainer width="100%" height="100%">
    <PieChart
      ref={ref}
      style={{
        cursor: 'pointer',
      }}
    >
      <Pie data={data} innerRadius={innerRadius} outerRadius={outerRadius} dataKey="value">
        {data?.map((entry, index) => <Cell key={`cell-${index}`} fill={entry?.color} />)}
      </Pie>
    </PieChart>
  </ResponsiveContainer>
));

export { StatusPieChart };
